import PropTypes from 'prop-types';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { Common } from '@stockbit/ui';

const fbAppId = process.env.NEXT_PUBLIC_FACEBOOK_APPID;

const { Text, Button, IconBase64 } = Common;
import { facebookIcon } from 'assets/base64icon';

// NotConnectedFacebook Component
const NotConnectedFacebook = ({
  handleNextStep,
  connectFacebook,
  handleFacebookResponse,
}) => {
  const size = 'medium';
  const renderSecondaryButton = (onClick) => {
    const buttonHeight = `${size === 'medium' ? 30.8 : 44}px`;
    const iconSize = `${size === 'medium' ? 16.8 : 24}px`;
    const fontSize = `${size === 'medium' ? 9.8 : 14}px`;

    return (
      <Button
        block
        round
        height={buttonHeight}
        justifyContent="start"
        id="facebook-register"
        onClick={(e) => {
          onClick(e);
        }}
        style={{ paddingLeft: 20, paddingRight: 20 }}
        className="my-facebook-button-class hide"
      >
        <IconBase64 icon={facebookIcon} iconSize={iconSize} padding="unset" />
        <Text
          color="light"
          size={fontSize}
          family="bold"
          width="100%"
          align="center"
        >
          Login with Facebook
        </Text>
      </Button>
    );
  };

  return (
    <>
      <div>
        <div className="boarding-fb" />

        <div className="boarding-title" style={{ margin: '25px 0' }}>
          Find Facebook Friends
        </div>

        <div className="boarding-text">
          You choose which friends to follow. We&apos;ll never <br />
          post to Facebook without your permission.
        </div>

        <div
          onClick={connectFacebook}
          onKeyDown={connectFacebook}
          role="button"
          tabIndex={-1}
          className="boarding-button fb"
        >
          Connect to Facebook
        </div>
      </div>

      {/* skip: go to discover people */}
      <div
        role="button"
        tabIndex={-1}
        className="boarding-skip"
        onClick={handleNextStep}
        onKeyDown={handleNextStep}
      >
        Skip
      </div>

      <div id="fb-root" />
      <div style={{ width: 250, margin: 'auto' }}>
        <FacebookLogin
          appId={fbAppId}
          autoLoad={false}
          style={{ fontSize: 40 }}
          scope="public_profile,email,user_friends"
          onSuccess={handleFacebookResponse}
          render={({ onClick }) => renderSecondaryButton(onClick)}
        />
      </div>
    </>
  );
};

NotConnectedFacebook.propTypes = {
  handleNextStep: PropTypes.func,
  connectFacebook: PropTypes.func,
  handleFacebookResponse: PropTypes.func,
};

NotConnectedFacebook.defaultProps = {
  handleNextStep: () => {},
  connectFacebook: () => {},
  handleFacebookResponse: () => {},
};

export default NotConnectedFacebook;
